function coerceId(id) {
  return id.replace(/[^0-9a-zA-Z_.-]/g, "");
}

// id parsing

const AREA_RE = /^([A-Z]+)/;
function getAreaId(fqid) {
  const result = AREA_RE.exec(fqid);
  return result?result[1]:undefined;
}

const UNIT_RE = /^[A-Z]+([0-9]+)/;
function getUnitId(fqid) {
  const result = UNIT_RE.exec(fqid);
  return result?result[1]:undefined;
}

const TOPIC_RE = /^[A-Z]+[0-9]+\.(.+)/;
function getTopicId(fqid) {
  const result = TOPIC_RE.exec(fqid);
  return result?result[1]:undefined;
}

const OUTCOME_RE = /^[A-Z]+[0-9]+o(.+)/;
function getOutcomeId(fqid) {
  const result = OUTCOME_RE.exec(fqid);
  return result?result[1]:undefined;
}

const AREA_ONLY_RE = /^[A-Z]+$/;
function isAreaId(fqid) {
  return AREA_ONLY_RE.exec(fqid);
}

const UNIT_ONLY_RE = /^[A-Z]+[0-9]+$/;
function isUnitId(fqid) {
  return UNIT_ONLY_RE.exec(fqid);
}

function isTopicId(fqid) {
  return fqid.indexOf('.')>-1;
}

function isOutcomeId(fqid) {
  return fqid.indexOf('o')>-1;
}

function isItemId(fqid) {
  return isTopicId(fqid)||isOutcomeId(fqid);
}


const createZeroCountsForType = (type)=>{
  const counts = {};
  for (let ei=0; ei<type.length; ei++) {
    const eid = type[ei].id;
    counts[eid] = {};
    for (let ci=0; ci<type[ei].choices.length; ci++) {
      const cid = type[ei].choices[ci].id;
      counts[eid][cid] = 0;
    }
  }
  return counts;
}

// assumes that ca and cb have the same type
// (or at least that cb contains a superset of eid/cid of ca)
const addItemCounts = (ca, cb)=>{
  const cc = {};
  for (const eid of Object.keys(ca)) {
    cc[eid] = {};
    for (const cid of Object.keys(ca[eid])) {
      cc[eid][cid] = ca[eid][cid]+cb[eid][cid];
    }
  }
  return cc;
}

const updateCounts = (item, counts)=>{
  //console.log("updateCounts()", item);
  for (const eid of Object.keys(item)) {
    const cid = item[eid];
    counts[eid][cid]++;
  }
}

const updateItemCounts = (item, fqid, itemKind, counts)=>{
  if (itemKind==='topics') {
    if (isTopicId(fqid)) {
      updateCounts(item, counts);
    }
  } else if (itemKind==='outcomes') {
    if (isOutcomeId(fqid)) {
      updateCounts(item, counts);
    }
  } else { // 'both' or undefined
    updateCounts(item, counts);
  }
}

const countFqid = (item, fqid, fqidPrefix, itemKind, counts)=>{
  if (getAreaId(fqidPrefix)) {
    if (getAreaId(fqidPrefix)===getAreaId(fqid)) {
      if (getUnitId(fqidPrefix)) {
        if (getUnitId(fqidPrefix)===getUnitId(fqid)) {
          if (getTopicId(fqidPrefix)) {
            if (getTopicId(fqidPrefix)===getTopicId(fqid)) {
              updateItemCounts(item, fqid, itemKind, counts); // topic match
            } // topic mismatch
          } else if (getOutcomeId(fqidPrefix)) {
            if (getOutcomeId(fqidPrefix)===getOutcomeId(fqid)) {
              updateItemCounts(item, fqid, itemKind, counts); // outcome match
            } // outcome mismatch
          } else {
            updateItemCounts(item, fqid, itemKind, counts); // unit match
          }
        } // unit mismatch
      } else { // no unit
        updateItemCounts(item, fqid, itemKind, counts); // area match
      }
    } // area mismatch
  } else { // no area
    updateItemCounts(item, fqid, itemKind, counts); // all match
  }
}

const countItems = (fqidPrefix, itemKind, items, type)=>{
  const counts = createZeroCountsForType(type);
  //console.log("counts (zero):", JSON.stringify(counts));
  const fqids = Object.keys(items);
  //console.log("fqids:", fqids);
  for (let i=0; i<fqids.length; i++) {
    const fqid = fqids[i];
    const item = items[fqid];
    countFqid(item, fqid, fqidPrefix, itemKind, counts);
  }
  //console.log("counts (after):", JSON.stringify(counts));
  return counts;
}




// reverse-engineered from Semantic UI
const colorValues = {
  'red': '#db2828',
  'orange': '#f2711c',
  'yellow': '#fbbd08',
  'olive': '#b5cc18',
  'green': '#21ba45',
  'teal': '#00b5ad',
  'blue': '#2185d0',
  'violet': '#6435c9',
  'purple': '#a333c8',
  'pink': '#e03997',
  'brown': '#a5673f',
  'grey': '#767676',
  'black': '#1b1c1d',
  'default': '#e8e8e8',
}

export {
  coerceId,
  getAreaId,
  getUnitId,
  getTopicId,
  getOutcomeId,
  isAreaId,
  isUnitId,
  isTopicId,
  isOutcomeId,
  isItemId,
  countItems,
  addItemCounts,
  colorValues
}